module.exports = __webpack_public_path__ + "static/shima-3f37e5651115bf3327a704fefd4497f0.png";